<div class="g-0">
    <div class="row">
        <div class="col-12">
            <div class="box-wrapper box-info" style="border: 2px solid #be71ec">
                <div class="box-content-header" style="background-color: #be71ec">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-circle-info"></i>
                                <span>Informații adiționale</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Informații</mat-button-toggle>
                                    <mat-button-toggle
                                        *ngIf="cerere?.informatii?.orar && cerere?.informatii?.orar?.length > 0"
                                        value="orar">Orar</mat-button-toggle>
                                    <mat-button-toggle
                                        *ngIf="cerere?.informatii?.suprafata_spatiu || cerere?.informatii?.suprafata_terasa"
                                        value="suprafata">Suprafață</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere?.informatii?.dovada_plata_taxa"
                                        value="taxa">Taxă</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-striped table-wrapper-box">
                        <tbody *ngIf="selectedInfoStatus === 'info' || 'suprafata' || 'taxa'">
                            <tr *ngFor="let field of currentFormFields">
                                <td *ngIf="field.fieldType === selectedInfoStatus" width="60%">
                                    <strong>{{ field.label }}</strong>
                                </td>
                                <td *ngIf="field.fieldType === selectedInfoStatus" width="40%">
                                    <ng-container [ngSwitch]="field.type">
                                        <!-- Boolean Type -->
                                        <ng-container *ngSwitchCase="'boolean'">
                                            {{ cerere?.informatii[field.value] ? 'Da' : 'Nu' }}
                                        </ng-container>

                                        <!-- Date Type -->
                                        <ng-container *ngSwitchCase="'date'">
                                            {{cerere?.informatii[field.value] ? (cerere?.informatii[field.value] | date:'dd-MM-yyyy HH:mm') : 'N/A' }}
                                        </ng-container>

                                        <!-- Acord Proprietate -->
                                        <ng-container *ngSwitchCase="'acord_proprietate'">
                                            {{ mapAcordProprietate(cerere?.informatii[field.value]) }}
                                        </ng-container>
                                        
                                        <!-- Act detinere spatiu -->
                                        <ng-container *ngSwitchCase="'act_detinere_spatiu'">
                                            {{ mapActDetinereSpatiu(cerere?.informatii[field.value]) }}
                                        </ng-container>

                                        <!-- Plata taxa -->
                                        <ng-container *ngSwitchCase="'plata_taxa'">
                                            {{ mapPlataTaxa(cerere?.informatii[field.value]) }}
                                        </ng-container>

                                        <ng-container *ngSwitchDefault>
                                            {{ cerere?.informatii[field.value] ? cerere?.informatii[field.value] : 'N/A'
                                            }}
                                        </ng-container>
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>

                        <tbody *ngIf="selectedInfoStatus === 'orar'">
                            <tr *ngFor="let day of formattedOrar">
                                <td width="60%"><strong>{{ day.dayName }}</strong></td>
                                <td width="40%">{{ day.businessHours }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>